import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from '../_COMPONENT/TableChooseExternalComponent.jsx'
import {useTableColumnBdName, useTableColumnBdNo} from '../BD/useTableColumnBd.jsx'

const TableChooseBdrule = (props) => {
    const columns = [
        useTableColumnBdName(),
        useTableColumnBdNo(),

        {
            title: '实体标题',
            dataIndex: 'ruleTitle',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseComponent
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseBdrule
